import React, {createContext, useContext, useState, useMemo, useEffect} from 'react';
import {PRISMAX_BACKEND_URL} from '../configs/config';
import {SwapMainAppContext} from "./SwapMainAppContext";

export const AuthContext = createContext();

export const AuthProvider = ({children}) => {
    const [isGatewayAuthenticated, setIsGatewayAuthenticated] = useState(false);
    const [gatewayUserData, setGatewayUserData] = useState(null);
    const {
        setUserEmail,
        setWalletAddress,
        walletAddress,
        clearUserData
    } = useContext(SwapMainAppContext);


    function disconnect() {
        setWalletAddress('');
    }


    const logout = async () => {
        const email = gatewayUserData?.email;
        if (isGatewayAuthenticated) {
            try {
                const response = await fetch(`${PRISMAX_BACKEND_URL}/logout`, {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify({email})
                });
                if (!response.ok) {
                    const result = await response.json();
                    console.error('Failed to logout:', result.msg);
                    return false;
                } else {
                    setGatewayUserData(null);
                    localStorage.clear();
                    clearUserData()

                    localStorage.setItem('emailLogin', 'false');
                    window.location.href = "/";
                    return true;
                }
            } catch (error) {
                console.error('Error while logging out:', error);
                return false;
            }
        } else {
            // Handle logout for non-gateway users
            console.log("Non-gateway user logout");
            setIsGatewayAuthenticated(false);
            setGatewayUserData(null);
            setGatewayUserData(null);
            localStorage.clear();
            clearUserData()

            localStorage.setItem('emailLogin', 'false');
            window.location.href = "/";
            return true;
        }
    };

    // email login
    const verifyGatewayToken = async (token) => {
        try {
            const response = await fetch(`${PRISMAX_BACKEND_URL}/verify_token`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({token})
            });
            if (!response.ok) {
                setIsGatewayAuthenticated(false);
                setGatewayUserData(null);
                return false;
            }

            const result = await response.json();
            if (result.success) {
                setIsGatewayAuthenticated(true);
                setGatewayUserData(result.data || null);
                //remove everything
                localStorage.clear();
                clearUserData()

                localStorage.setItem("userEmail", result.data.email || null);
                if (result.data.email) {
                    setUserEmail(result.data.email)
                }
                //
                if (result.data.linked_wallet_address) {
                    localStorage.setItem("walletAddress", result.data.linked_wallet_address);

                }
                if (result.data.total_points) {
                    localStorage.setItem("totalPoints", result.data.total_points);
                }
                if (result.data.user_class) {
                    localStorage.setItem("userClass", result.data.user_class);
                }
                if (result.data.userid) {
                    localStorage.setItem("userId", result.data.userid);
                }
                return true;
            } else {
                setIsGatewayAuthenticated(false);
                setGatewayUserData(null);
                return false;
            }
        } catch (error) {
            console.error('Error verifying gateway token:', error);
            setIsGatewayAuthenticated(false);
            setGatewayUserData(null);
            return false;
        }
    };

    // use useMemo cache gatewayUserDate
    const memoizedGatewayUserData = useMemo(() => gatewayUserData, [gatewayUserData?.email]);

    return (
        <AuthContext.Provider
            value={{
                isGatewayAuthenticated,
                gatewayUserData: memoizedGatewayUserData,
                logout,
                verifyGatewayToken,
                walletAddress,
                setWalletAddress,
                disconnect
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);